import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { ButtonBack } from "../Button/Back";
import { ConfirmationModal } from "../UI/ConfirmationModal/ConfirmationModal";
import SelectSearch from "../UI/SelectSearch/SelectSearch";
import api from "../../services/api";
import DatePicker , { registerLocale }from "react-datepicker";
import pt_br from "date-fns/locale/pt-BR";
import "react-datepicker/dist/react-datepicker.css";

registerLocale("pt_br", pt_br);

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

export const SecureDirectoryConfiguration =

withRouter(

// redux
connect(
	(null), 
	(mapDispatchToProps)
)(

	class extends Component {

		constructor(props){
			super(props);
			this.state = {
				exibeModalConfirmacao: false,
				pastasSegurasDisponiveis: [],
				carregandoPastasSegurasDisponiveis: true,
			};
			
			this.handleInputChange = this.handleInputChange.bind(this);
			this.validaAlteracaoDaPastaSegura = this.validaAlteracaoDaPastaSegura.bind(this);
			this.validaConclusaoDaPastaSegura = this.validaConclusaoDaPastaSegura.bind(this);
			this.confirmaOperacao = this.confirmaOperacao.bind(this);
			this.concluirConfiguracaoPastaSeguraSolicitacao = this.concluirConfiguracaoPastaSeguraSolicitacao.bind(this);
			this.alterarAndamentoConfiguracaoPastaSegura = this.alterarAndamentoConfiguracaoPastaSegura.bind(this);
		}

		componentDidMount() {
			api.get('/api/pasta-segura-disponivel/disponiveis')
				.then(response => {
					this.setState({
						pastasSegurasDisponiveis: response.data || [],
						carregandoPastasSegurasDisponiveis: false,
					});
				})
				.catch(() => {
					this.setState({
						pastasSegurasDisponiveis: [],
						carregandoPastasSegurasDisponiveis: false,
					});
				});
		}

		render() {
			return (
				<div>
					{this.renderForm()}
				</div>
			);
		}

		renderForm() {
			const { solicitacao, botoesHabilitados } = this.props;
			return(
				<div className="container-fluid">
					<ConfirmationModal
						isOpen={this.state.exibeModalConfirmacao}
						onClose={() => this.fechaModal()}
						onConfirm={() => this.executaOperacao()}
						message={this.state.msgModal}
					/>

				<div className="container-fluid">
                    <div className="mt-4 mb-4">
                        <h2>Pasta Segura</h2>
                    </div>
					 <div className="br-form">
						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<div className="d-flex">
											<label htmlFor="ipsInternet">IP's de Internet:&nbsp;</label>
										</div>
										<input type="text" name="ipsInternet" 
											value={solicitacao.ipsInternet}  
											readOnly />
									</div>
								</div>
							</div>
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label htmlFor="so">Sistema operacional da pasta segura:</label>
										<input type="text" name="nomeSo"  readOnly
											value={solicitacao.nomeSo ? solicitacao.nomeSo : ""}
										/>
									</div>
								</div>
							</div>
						</div> 
						<div className="row">
                            <div className="col-md">
                                <div className="field">
                                    <div className="input">
                                        <label htmlFor="nomePastaSegura">Nome da Pasta Segura:</label>
                                        <SelectSearch
                                            id="nomePastaSegura"
                                            name="nomePastaSegura"
                                            options={this.getOpcoesPastaSegura(solicitacao.nomePastaSegura)}
                                            onChange={this.handleInputChange}
                                            value={solicitacao.nomePastaSegura}
                                            disabled={!solicitacao.configuracaoPastaSeguraPermitida}
                                        />
                                        {this.state.carregandoPastasSegurasDisponiveis === true &&
                                            <button className="br-button is-secondary is-circle is-loading" type="button"/>
                                        }
                                    </div>
                                </div>
                            </div>
							<div className="col-md">
                                <div className="field">
                                    <div className="input">
                                        <label htmlFor="andamentoImplantacao">Informações do Andamento da implantação da Pasta Segura:</label>
                                        <textarea type="text" name="andamentoImplantacao" 
                                            value={solicitacao.andamentoImplantacao}  
                                            onChange={this.handleInputChange} 
											readOnly={!solicitacao.configuracaoPastaSeguraPermitida}
                                            maxLength="500"/>
                                    </div>
                                </div>
                            </div>
						</div> 
                        <div className="row">
							<div className="col-md">
                                <div className="field">
                                    <div className="input">
                                        <label htmlFor="dataConclusaoImplantacao">Data da Conclusão da Implantação:</label>
										<DatePicker 
											locale="pt_br" 
											dateFormat="dd/MM/yyyy" 
											readOnly={!solicitacao.configuracaoPastaSeguraPermitida}
											selected={solicitacao.dataConclusaoImplantacao} 
												disableClock={true}
												onChange={data => {
													const { onChangeProperties } = this.props;
													if (onChangeProperties) {
														onChangeProperties("dataConclusaoImplantacao", data);
													}
												}}
											/>
                                    </div>
                                </div>
                            </div>
                        </div>
						<div className="actions-button">
							<div className="actions justify-content-start">
								{solicitacao.configuracaoPastaSeguraPermitida && 
									<Fragment>
										<button type="button" className="button is-primary" onClick={(e) => this.alterarAndamentoConfiguracaoPastaSegura(e)} disabled={!botoesHabilitados}>Alterar</button>
										<button type="button" className="button is-secondary" onClick={(e) => this.confirmaOperacao(e, this.concluirConfiguracaoPastaSeguraSolicitacao, "Deseja realmente concluir a pasta segura?", this.validaConclusaoDaPastaSegura)}  disabled={!botoesHabilitados}>Concluir</button>
									</Fragment>
								}
								<ButtonBack disabled={!botoesHabilitados} />								
							</div>
						</div>
					</div> 
				</div>
                </div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;

			const { onChangeProperties } = this.props;
			if (onChangeProperties) {
				onChangeProperties(nome, valor);
			}
		}

		getOpcoesPastaSegura(nomePastaSeguraAtual){
			const { pastasSegurasDisponiveis } = this.state;
			const opcoes = pastasSegurasDisponiveis.map(nome => ({ value: nome, label: nome }));

			// Mantém o valor já configurado como opção, mesmo que não esteja mais
			// disponível, para não perder uma seleção já salva e ainda não concluída.
			if (nomePastaSeguraAtual && !pastasSegurasDisponiveis.includes(nomePastaSeguraAtual)) {
				opcoes.push({ value: nomePastaSeguraAtual, label: nomePastaSeguraAtual });
			}

			return opcoes;
		}
	
		confirmaOperacao(e, operacao, msgModal, validacao) {
			if(validacao) {
				try{
					validacao(e);
				}catch(erroValidacao){
					e.preventDefault();
					return;
				}
			}

			this.setState(
				{
					exibeModalConfirmacao: true,
					operacao,
					msgModal,
				}
			);
		}

		executaOperacao () {
			this.state.operacao();
			this.fechaModal();
		}

		alterarAndamentoConfiguracaoPastaSegura(e) {
			try{
				this.validaAlteracaoDaPastaSegura(e);
			}catch(erroValidacao){
				e.preventDefault();
				return;
			}
			
			if(this.props.alterarAndamentoConfiguracaoPastaSegura){
				this.props.alterarAndamentoConfiguracaoPastaSegura();
			}
		}

		concluirConfiguracaoPastaSeguraSolicitacao() {
			if(this.props.concluirConfiguracaoPastaSeguraSolicitacao){
				this.props.concluirConfiguracaoPastaSeguraSolicitacao();
			}
		}

		validaAlteracaoDaPastaSegura(){
			let mensagens = [];
			const { andamentoImplantacao } = this.props.solicitacao;

			if(!andamentoImplantacao || andamentoImplantacao.trim().length === 0 ){
				mensagens.push({mensagem: "Andamento da implantação é obrigatório."})
			}

			if(mensagens.length > 0){
				this.props.exibeMensagemErro("Não foi possível realizar a operação porque há inconsistências nos campos informados:", mensagens)
				throw new Error("Pasta Segura não preenchida corretamente.");
			}
		}

		validaConclusaoDaPastaSegura(){
			let mensagens = [];
			const { nomePastaSegura, dataConclusaoImplantacao } = this.props.solicitacao;

			if(!nomePastaSegura || nomePastaSegura.trim().length === 0 ){
				mensagens.push({mensagem: "Nome da Pasta Segura é obrigatório."})
			}
			
			if(!dataConclusaoImplantacao ){
				mensagens.push({mensagem: "Data de conclusão da implantação da Pasta Segura é obrigatória."})
			}

			if(mensagens.length > 0){
				this.props.exibeMensagemErro("Não foi possível realizar a operação porque há inconsistências nos campos informados:", mensagens)
				throw new Error("Pasta Segura não preenchida corretamente.");
			}
		}

		fechaModal () {
			this.setState(
				{
					exibeModalConfirmacao: false,
				}
			);
		}
	}
	

) // redux
); // router